(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();

      this.burger = this.querySelector('.mriya-header__burger');
      this.mobileNav = this.querySelector('.mriya-header__mobile-nav');
      this.mobileLinks = this.querySelectorAll('.mriya-header__mobile-link');

      if (this.burger && this.mobileNav) {
        this.burger.addEventListener('click', () => {
          const isOpen = this.mobileNav.classList.toggle('is-open');
          this.burger.classList.toggle('is-open', isOpen);
          this.burger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });

        this.mobileLinks.forEach((link) => {
          link.addEventListener('click', () => {
            this.mobileNav.classList.remove('is-open');
            this.burger.classList.remove('is-open');
            this.burger.setAttribute('aria-expanded', 'false');
          });
        });
      }

      document.querySelectorAll('a[href*="#"]').forEach((link) => {
        link.addEventListener('click', (event) => {
          const href = link.getAttribute('href');
          if (!href || href === '#') return;

          let url;
          try {
            url = new URL(href, window.location.origin);
          } catch (_error) {
            return;
          }

          if (url.origin !== window.location.origin || url.pathname !== window.location.pathname || !url.hash) return;

          const target = document.querySelector(url.hash);
          if (!target) return;

          event.preventDefault();
          const headerOffset = this.header ? this.header.offsetHeight + 12 : 12;
          const targetTop = target.getBoundingClientRect().top + window.scrollY - headerOffset;
          window.scrollTo({ top: targetTop, behavior: 'smooth' });

          if (this.mobileNav && this.burger) {
            this.mobileNav.classList.remove('is-open');
            this.burger.classList.remove('is-open');
            this.burger.setAttribute('aria-expanded', 'false');
          }
        });
      });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      const observer = new IntersectionObserver((entries, currentObserver) => {
        this.headerBounds = entries[0].intersectionRect;
        currentObserver.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
